import { create } from "zustand";

/** Active interaction tool on the canvas. */
export type Tool = "select" | "draw" | "measure";

interface ToolState {
  activeTool: Tool;
  setTool: (tool: Tool) => void;
}

/**
 * Global tool state machine.
 * All pointer events on the R3F canvas route through the active tool.
 */
export const useToolStore = create<ToolState>((set) => ({
  activeTool: "select",
  setTool: (tool) => set({ activeTool: tool }),
}));
